import React, { useEffect } from "react";
import { FaPlug, FaCogs, FaCheckCircle, FaTools, FaBolt, FaMicrochip, FaShieldAlt, FaIndustry } from "react-icons/fa";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import collab from "../../assets/PCB.png";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Wirringharness.css";

export default function WiringHarness() {
  const stages = [
    {
      icon: <FaPlug className="wiring-step-icon" />,
      title: "Crimping",
      desc: "Secure connections with advanced crimping technology",
    },
    {
      icon: <FaCogs className="wiring-step-icon" />,
      title: "Assembly",
      desc: "Expert assembly of wiring harnesses for optimal performance",
    },
    {
      icon: <FaCheckCircle className="wiring-step-icon" />,
      title: "Circuit Inspection",
      desc: "Thorough verification of circuit integrity and functionality",
    },
    {
      icon: <FaTools className="wiring-step-icon" />,
      title: "Final Inspection",
      desc: "Rigorous quality control to ensure defect-free harnesses",
    },
  ];

  const benefits = [
    { title: "Quality Assurance", desc: "We prioritize quality and reliability in every harness" },
    { title: "Efficient Production", desc: "Streamlined processes for timely delivery" },
    { title: "Custom Solutions", desc: "Tailored wiring harnesses to meet your specific needs" },
  ];

  const features = [
    { icon: <FaBolt />, text: "High-performance wiring solutions for demanding environments" },
    { icon: <FaMicrochip />, text: "Integration with advanced electronics and control systems" },
    { icon: <FaShieldAlt />, text: "Safety-focused designs ensuring durability and protection" },
  ];

  const industries = [
    { icon: <FaIndustry />, title: "Automotive", desc: "Reliable harnesses for modern vehicles" },
    { icon: <FaIndustry />, title: "Aerospace", desc: "Lightweight and safe solutions for aviation" },
    { icon: <FaIndustry />, title: "Industrial Equipment", desc: "Durable harnesses for heavy machinery" },
    { icon: <FaIndustry />, title: "Consumer Electronics", desc: "Compact harnesses for smart devices" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="wiring-page-content">
      <Header />

      {/* Hero Section */}
      <section
        className="wiring-hero"
        style={{ backgroundImage: `url(${collab})` }}
      >
        <div className="wiring-hero-overlay"></div>
        <h1 className="wiring-hero-title">MES for Wiring Harness Process</h1>
      </section>

      {/* Hero Content */}
      <section className="wiring-hero-content">
        <h2>Optimize Your Wiring Harness Production</h2>
        <p>
          We specialize in crafting high-quality wiring harnesses with precision
          and care. Our manufacturing process ensures excellence at every stage.
        </p>
      </section>

      {/* Key Stages */}
      <section className="wiring-process-flow">
        <h2>Key Stages</h2>
        <div className="wiring-process-steps">
          {stages.map((stage, i) => (
            <div key={i} className="wiring-step">
              {stage.icon}
              <h3>{stage.title}</h3>
              <p>{stage.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="wiring-benefits">
        <h2>Why Choose Us?</h2>
        <div className="wiring-benefits-grid">
          {benefits.map((benefit, i) => (
            <div key={i} className="wiring-benefit">
              <h3>{benefit.title}</h3>
              <p>{benefit.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Capabilities Section */}
      <section className="wiring-features">
        <h2>Our Capabilities</h2>
        <ul>
          {features.map((f, i) => (
            <li key={i}>
              <span className="feature-icon">{f.icon}</span>
              {f.text}
            </li>
          ))}
        </ul>
      </section>

      {/* Industries Served Section */}
      {/* <section className="wiring-industries">
        <h2>Industries We Serve</h2>
        <div className="wiring-industries-list">
          {industries.map((ind, i) => (
            <div key={i} className="wiring-industry">
              <span className="industry-icon">{ind.icon}</span>
              <h3>{ind.title}</h3>
              <p>{ind.desc}</p>
            </div>
          ))}
        </div>
      </section> */}

      <Footer />
      <ERPChatbot />
    </div>
  );
}
